import React from 'react';
import { Link } from 'react-router-dom';
import { Loader2, LockKeyhole, RefreshCw } from 'lucide-react';
import { useProcurementAccess } from '../context/ProcurementAccessContext';
import { useLanguage } from '../context/LanguageContext';
import type { ProcurementFeature } from '../api/procurement';
import ProcurementTrialPanel from './ProcurementTrialPanel';

export default function ProcurementAccessGate({ feature, children, compact = false, fallback }: {
  feature: ProcurementFeature; children?: React.ReactNode; compact?: boolean; fallback?: React.ReactNode;
}) {
  const { loading, error, allowed, refresh } = useProcurementAccess();
  const { t } = useLanguage();
  if (!loading && allowed(feature)) return <>{children}</>;
  if (!loading && !error && fallback) return <>{fallback}</>;
  return <div className={compact ? 'w-full min-w-0' : 'w-full min-w-0 px-4 py-8 sm:px-6 sm:py-10'}>
    <section className={`${compact ? 'p-5' : 'mx-auto max-w-3xl p-6 sm:p-8'} rounded-2xl border border-slate-200 bg-white shadow-sm`}>
    {loading ? <p role="status" className="flex items-center gap-3 text-sm text-slate-600"><Loader2 aria-hidden="true" className="h-5 w-5 shrink-0 animate-spin text-goszakup-600" />{t('procurement.loading')}</p> : <>
      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-sky-50 text-goszakup-700"><LockKeyhole aria-hidden="true" className="h-5 w-5" /></div>
      <h2 className="mb-2 text-lg font-bold leading-7 text-slate-900">{t(error ? 'procurement.accessError' : 'procurement.denied')}</h2>
      <p className="mb-6 max-w-prose text-sm leading-6 text-slate-600">{t('procurement.deniedHint')}</p>
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap"><Link className="procurement-button-primary" to="/plans">{t('procurement.plans')}</Link>
        <button type="button" onClick={() => void refresh()} className="procurement-button"><RefreshCw aria-hidden="true" className="h-4 w-4" />{t('procurement.retry')}</button></div>
      {!error && <div className="mt-5"><ProcurementTrialPanel compact /></div>}
    </>}
    </section>
  </div>;
}
